import { BeneficiaryContentRowType } from '../types';

import cn from '../styles.module.css';

const BeneficiaryContentRow = ({
  name,
  value,
  error,
}: BeneficiaryContentRowType) => (
  <>
    <div className={cn.beneficiaryContentRow}>
      <div className={cn.beneficiaryContentRowTitle}>{name}</div>
      <div className={cn.beneficiaryContentRowValue}>{value}</div>
    </div>
    {error && <div className={cn.beneficiaryContentRowError}>{error}</div>}
  </>
);

export default BeneficiaryContentRow;
